import React, { FunctionComponent, useContext } from "react";
import URI from "urijs";
import { CoverageType } from "../QuestionRoutingPage/types";
import { RouteComponentProps } from "react-router";
import routes from "../../app/routes";
import { AppContext } from "../../app/store";
import { parseSearchParams } from "../../helpers";

enum WizardCoverageType {
  Medigap = "medigap",
  PDPAndMedigap = "pdp_medigap",
  PDP = "pdp",
  OriginalMedicare = "om",
  MAPD = "mapd",
}

const CoverageSelectionPage: FunctionComponent<RouteComponentProps> = ({
  location,
  history,
}) => {
  const { state } = useContext(AppContext);
  const uri = new URI(location.search);

  // The coverage wizard will pass fips, zip, planType, and year as query parameters to this page
  const { zip, fips, planType, year } = parseSearchParams(uri.search(true));

  const cwToMctCoverageTypes = {
    [WizardCoverageType.Medigap]: CoverageType.MedigapPolicy,
    [WizardCoverageType.PDPAndMedigap]: CoverageType.PDPAndMedigap,
    [WizardCoverageType.PDP]: CoverageType.PDP,
    [WizardCoverageType.MAPD]: CoverageType.MAPD,
    [WizardCoverageType.OriginalMedicare]: CoverageType.OriginalMedicare,
  };

  const convertedPlanType =
    cwToMctCoverageTypes[planType as WizardCoverageType];
  const redirectRoute = state.beneficiary
    ? routes.beneLanding
    : routes.questionRouting;

  if (convertedPlanType && zip && fips) {
    const redirect = new URI(redirectRoute)
      .addQuery("zip", zip)
      .addQuery("fips", fips)
      .addQuery("planType", convertedPlanType)
      .addQuery("year", year);

    history.push(redirect.toString());
  } else {
    history.push(redirectRoute);
  }

  return <div />;
};

export default CoverageSelectionPage;
